import React from 'react';
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import "./slick.css";

const Projects = ({ hideText, projects }) => {
    const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 1,
        autoplay: true,
    };

    return (
        <div className={`container center pt-5 projects-list translate-dynamic ${isMobile ? "px-4" : ""} `}>
            <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
            <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
            {
                hideText != true &&
                <div className="center mb-4 mw-800px">
                    <h4 className="font-bold">Support Projects That Fight Climate Change</h4>
                    <p className="mobile-hide">Climate Friendly Traveller supports only the highest quality carbon offsetting projects around the world, to bring you peace of mind and results.</p>
                </div>
            }

            {projects.length > 2 ?
                <Slider {...settings}>
                    {projects.map(data =>
                        <div className="d-grid px-2" >
                            <SingleProject project={data} />
                        </div>
                    )}
                </Slider>
                :
                <div className="row justify-center">
                    {projects.map(data =>
                        <div className="d-grid col-4" >
                            <SingleProject project={data} />
                        </div>
                    )}
                </div>
            }
        </div>
    );
};


const SingleProject = ({ project }) => {
    return (
        <div className="project-card mb-3">
            <div>
                <div className="h-160px img-cover" style={{ backgroundImage: `url(${project.thumbnailImageUrl})` }}>

                </div>
            </div>
            <div className="p-3">
                <h5 className="font-bold">{project.name}</h5>
                <p className="mb-0">{project.locationDescription}</p>
                <a className="color-primary font-bold" target="_blank" rel="noopener noreferrer" href={`${process.env.MY_CC_URL}/projects/${project.code}`} >Learn More</a>
            </div>
        </div>
    )
}


export default Projects;
